import styled, { css } from 'styled-components';
import { theme } from '../layout/theme';

const HeadingBase = styled.div`
  margin: 0;
  font-weight: 500;
  font-family: ${theme.font.family.brand};
  letter-spacing: ${theme.font.letterSpacing};

  &.alt-font {
    font-family: inherit;
    font-weight: 600;
  }

  &.bold {
    font-weight: 700;
  }
  
  &.italic {
    font-style: italic;
  }
`;

// CSS blocks used to style headings in other styled-components

const StyledH1 = css`
  font-size: 32px;
  line-height: 1.25;

  ${theme.screens.Md} {
    font-size: 40px;
    line-height: 1.2;
  }
`;

const StyledH2 = css`
  font-size: 24px;
  line-height: 1.333;

  ${theme.screens.Md} {
    font-size: 32px;
    line-height: 1.25;
  }
`;

const StyledH3 = css`
  font-size: 20px;
  line-height: 1.2;

  ${theme.screens.Md} {
    font-size: 24px;
    line-height: 1.333;
  }
`;

const StyledH4 = css`
  font-size: 16px;
  line-height: 1.5;

  ${theme.screens.Md} {
    font-size: 20px;
    line-height: 1.4;
  }
`;

const StyledH5 = css`
  font-size: 12px;
  line-height: 1.5;

  ${theme.screens.Md} {
    font-size: 16px;
    line-height: 1.4;
  }
`;

// Heading components used in React components

export const H1 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h1',
}))`
  ${StyledH1}
`;

export const H2 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h2',
}))`
  ${StyledH2}
`;

export const H3 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h3',
}))`
  ${StyledH3}
`;

export const H4 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h4',
}))`
  ${StyledH4}
`;

export const H5 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h5',
}))`
  ${StyledH5}
`;
